import { css } from '@linaria/atomic';

export const notFoundPageStyles = css`
  min-height: 100vh;
  display: grid;
  place-items: center;
  background: linear-gradient(120deg, var(--fabric-color-seaweed-10, #e0f2f1), var(--fabric-color-blue-10, #dcebfe));
`;

export const notFoundContentStyles = css`
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: var(--fabric-space-gap-md);
  padding: var(--fabric-space-padding-xl);
`;
